// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/availability_window.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_money } from "./money_pb";

/**
 * Describes the file proto/model/core/availability_window.proto.
 */
export const file_proto_model_core_availability_window = /*@__PURE__*/
  fileDesc("Cipwcm90by9tb2RlbC9jb3JlL2F2YWlsYWJpbGl0eV93aW5kb3cucHJvdG8SBmNhcm1lbiKGAQoSQXZhaWxhYmlsaXR5V2luZG93EikKBXN0YXJ0GAEgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBInCgNlbmQYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhwKBXByaWNlGAMgASgLMg0uY2FybWVuLk1vbmV5QihaJmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsYgZwcm90bzM", [file_google_protobuf_timestamp, file_proto_model_core_money]);

/**
 * Describes the message carmen.AvailabilityWindow.
 * Use `create(AvailabilityWindowSchema)` to create a new message.
 */
export const AvailabilityWindowSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_availability_window, 0);

